export enum KpiCalculationType {
  GreaterOrEqual = 1, // az elért eredmény nagyobb vagy egyenlő, mint a kitűzött eredmény
  LessOrEqual = 2,    // az elért eredmény kisebb vagy egyenlő, mint a kitűzött eredmény
  ExactlyEqual = 3    // az elért eredmény pontosan megegyezik a kitűzött eredménnyel
}
